import { Navigate, useParams } from 'react-router-dom';

// The old `/share/:token` links. Guest links live at `/guest-share/:token`
// (made in the share dialog's Guest link tab).
export const ShareView = () => {
  const { token } = useParams();
  return <Navigate to={`/guest-share/${token}`} replace />;
};

export default ShareView;
